import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Grid from '@material-ui/core/Grid';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@material-ui/icons/Refresh';
import InfoIcon from '@material-ui/icons/Info';
import PortletToolbar from 'components/PortletToolbar';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import ClearIcon from '@material-ui/icons/Clear';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import {StickyTable, Row, Cell} from 'react-sticky-table';

import Period from '../../../../helpers/PeriodGeneralStatus';
import ObjectiveCell from './ObjectiveCell';
import Filter from '../../../..//helpers/Filter';
import ListObjectiveModal from '../ListObjectiveModal';
import {getObjectives} from '../../../../services/getObjectives'
import { reportFetchError } from '../../../../observability/rum';

import Avatar from '@material-ui/core/Avatar';
import UpdateIcon from '@material-ui/icons/Update';
import moment from 'moment-timezone'
import 'moment/locale/es'  
import { FilterTags } from '../../../../components/TagsAtentus/FilterTags';
import queryString from 'query-string';
import { compose } from 'underscore';
import { NavLink, withRouter } from 'react-router-dom';
import { sidebarFiltersTags } from '../../../../utils/local-storage/sidebar-options';
import { getQueryParams } from '../../../../utils/fns/get-query-params';
import { Box, Dialog, FormControlLabel, Switch,  TableContainer,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Table, } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
moment.locale('es')
const date=((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a"))

const INTERVAL_TIME = 300000

class QuickViewIspFull extends Component {
    constructor(props) {
        super(props);
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        const estados = [t('quickview.status-list.Activos'), t('quickview.status-list.Downtime'), t('quickview.status-list.Downtime-Parcial'), t('quickview.status-list.Uptime'), t('quickview.status-list.Todos')];
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        const parsed = queryString.parse(props.location.search);
        const etiquetas = parsed?.etiquetas && parsed?.etiquetas !== ''
        ? parsed?.etiquetas.split('T').map(e => Number(e)) ?? [] : [];
        let filter = parsed?.estado;
        var filterList=[{"nombre":t('filter.status-list.Activos')},{"nombre":t('filter.status-list.Downtime')}, {"nombre":t('filter.status-list.Downtime-Parcial')}, {"nombre":t('filter.status-list.Uptime')},{"nombre":t('filter.status-list.Todos')}]
        if(!filter && sessionStorage.getItem("filterOperative")!==null){
            filter=sessionStorage.getItem("filterOperative")
        } else if (!filter || !estados.includes(filter)) {
            filter = "Activos"
        }
        var newFilterList=[{"nombre":t('filter.status-list.'+filter)}]
        filterList.map(ele=>{
            if(ele.nombre!==filter){
                newFilterList.push(ele)
            }
        })
        filterList=newFilterList

        const filterTypeFromStorage = sidebarFiltersTags.getFilterType();
        
        const filterType = parsed?.filterType ?? filterTypeFromStorage;
        
        this.state = {
            isOpen: false,
            path: null,
            listObjectives: {},
            nameStatus: 'Objetivos ',
            selectedOption: null,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            isStatePeriod: false,
            settingsEl: null,
            isInfo: null,
            date: moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a"),
            objmodal: 0,
            objNameModal: '',
            openObjectiveModal: false,
            typeGraph: 0,
            period: 'h',
            namePeriod: null,
            namePeriodPorlet: ['Última Hora', 'Últimas 3 horas', 'Últimas 6 horas', 'Últimas 12 horas', 'Último día', 'Últimos 2 días'],
            typePeriod: 0,
            left: 0,
            changeFilter: false,
            filter: filter,
            filterList: filterList,
            newInterval: null,
            filterTagsId: etiquetas,
            filterTagsType: filterType,
            showPatronesInversos: false,
        }

        this.myRef = React.createRef();

    }
    
    setHoverData = (e) => {

        const { params } = this.state
        let name = e.point.name
        this.setState({
            isOpen: true,
            nameStatus: 'Objetivos ' + name,
            listObjectives: params[name]
        });
    }
    setHoverDataBar = (e) => {

        const { params } = this.state
        const { category, series } = e.point
        let nameCat = category
        let nameStatus = series.name
        var filterParams = params[nameStatus].filter(param => param['grupo_servicio_unificado'] == nameCat)
        this.setState({
            isOpen: true,
            nameStatus: 'Objetivos ' + nameCat,
            listObjectives: filterParams
        });
    }
    onOpenModal = () => {
        this.setState({ isOpen: true });
    };

    onCloseModal = () => {
        this.setState({ isOpen: false });
    };

    tick=()=>{
        sessionStorage.setItem("listsLoadsDisponibilidad",false)
        sessionStorage.setItem("listsLoads",false)
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        // window.location.reload()
        var filter="Activos"
        var filterList=[{"nombre":t('filter.status-list.Activos')},{"nombre":t('filter.status-list.Downtime')}, {"nombre":t('filter.status-list.Downtime-Parcial')}, {"nombre":t('filter.status-list.Uptime')},{"nombre":t('filter.status-list.Todos')}]
        if(sessionStorage.getItem("filterOperative")!==null){
            filter=sessionStorage.getItem("filterOperative")
            var newFilterList = [{"nombre":t('filter.status-list.'+filter)}]
            filterList.map(ele=>{
                if(ele.nombre!==filter){
                    newFilterList.push(ele)
                }
            })
            filterList = newFilterList
        }
        this.setState({
            isLoading: true,
            filterList: filterList
        })
        this.processData()
    }

    componentDidMount() {
        const initFunction = async () => {
            await this.processData()
            const newInterval = setInterval(
                () => this.tick(),
                INTERVAL_TIME
            )
            this.setState({intervalId: newInterval})
        }
        initFunction()
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId)
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.t !== prevProps.t) {
            const queryParamsParsed = queryString.parse(document.location.search);
            const parsed = queryString.parse(this.props.location.search);
            const activeTab = parsed?.tab ?? '1';
            queryParamsParsed['tab'] = activeTab
            queryParamsParsed["etiquetas"] = this.state.filterTagsId.join("T");
            queryParamsParsed["filterType"] = this.state.filterTagsType;
            queryParamsParsed['estado'] = this.state.filter
            queryParamsParsed['filterTagsType'] = this.state.filterTagsType;
            window.history.replaceState(
                null,
                'Vista Rápida por Isp / Semáforo',
                `/quickviewisplights?${queryString.stringify(
                    queryParamsParsed,                
                )}`
            );
            var filterList=[{"nombre":this.props.t('filter.status-list.Activos')},
                {"nombre":this.props.t('filter.status-list.Downtime')}, 
                {"nombre":this.props.t('filter.status-list.Downtime-Parcial')}, 
                {"nombre":this.props.t('filter.status-list.Uptime')},
                {"nombre":this.props.t('filter.status-list.Todos')}]
            this.setState({filterList: filterList});
        }
    }

    processData = () => {
        this.setState({isLoading: true})
        const { params } = this.props;
        var data = params
        const token = sessionStorage.getItem('key')
        const user_id = sessionStorage.getItem('user')
        /*OBTIENE OBJETIVOS POR ESTADO*/
        getObjectives(user_id, token).then(dataFetch=>{
            data = dataFetch
            sessionStorage.setItem("listsLoads",true)
            return new Promise(resolve => {
                let objectivesList = []
                let nodesList = []
                Object.keys(data).map((key) => {
                    if (key !== 'Services' && key !=='ServicesUnified' && key != 'NoMonitoringPartial') {
                        Object(data[key]).map((objective, orden)=>{
                            if (objective['estado'] == 'Uptime'){
                                objective['color_custom'] = 'rgb(65, 185, 0)'
                            } else if (objective['estado'] == 'Downtime'){
                                objective['color_custom'] = 'rgb(194, 39, 45)'
                            } else if (objective['estado'] == 'Parcial'){
                                objective['color_custom'] = 'rgb(255, 198, 0)'
                            } else if (objective['estado'] == 'No monitoreo'){
                                objective['color_custom'] = 'rgb(169, 169, 169)'
                            }
                            objective['nombre'] = objective['nombre'].replaceAll('/', '|')
                            objectivesList.push(objective)
                            Object(objective.Nodos).map((node, orden)=>{
                                nodesList.push(node)
                            })
                        })
                    }
                })
                var order = {'Downtime': 1, "Parcial": 2, "Uptime": 3, "No monitoreo": 4};
                objectivesList.sort(function (a, b) {
                    var priorityA = order[a.estado] || Infinity;
                    var priorityB = order[b.estado] || Infinity;

                    var nombreA = (a.nombre).toLowerCase()
                    var nombreB = (b.nombre).toLowerCase()

                    if (priorityA < priorityB) return -1;
                    if (priorityA > priorityB) return 1;

                    if (nombreA < nombreB) return -1;
                    if (nombreA > nombreB) return 1;
                    return 0;
                });
                var groupedNodes = groupBy(nodesList, 'id_nodo');
                let nodesIdList = []
                let nodesMonitorsIdList = []
                Object.keys(groupedNodes).map(key => {
                    if (key != 0){
                        nodesIdList.push(key)
                        nodesMonitorsIdList.push(groupedNodes[key])
                    }
                })
                this.setState({
                    objectivesList: objectivesList,
                    nodesList: nodesList,
                    nodesIdList: nodesIdList,
                    nodesMonitorsIdList: nodesMonitorsIdList,
                    groupedNodes: groupedNodes,
                    loadObjectiveData: true,
                    listObjetivesData: data,
                    isLoading: false,
                    params: data,
                    date: moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a")
                });
            });
        })
        .catch((error) => {
            reportFetchError('QuickViewIspFull', error)
            this.setState({ isLoading: false })
        })
    }

    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };

    handleChange = (selectedOption) => {
        const { passProps } = this.props
        this.setState({ selectedOption });
        //passProps.onClick(passProps, selectedOption.value)
    };
    
    handleShowSettings = event => {
        this.setState({
            settingsEl: event.currentTarget
        });
    };
    handleCloseSettings = () => {
        this.setState({
            settingsEl: null
        });
    };

    handleRefresh = () => {
        this.tick()
    };

    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };

    
    handleOpenObjectiveModal = event => {      
        const objId = event.currentTarget.id
        const objName = event.currentTarget.value       
        if (this.state.openObjectiveModal == false){
            this.setState({
                openObjectiveModal: true,
                objIdModal: objId,
                objNameModal: objName
            })
        }        
    };
    
    handleCloseObjectiveModal  = event => {
        this.setState({
            openObjectiveModal: false,
        })
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {
        if (nextPeriod === 'hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: 'h',
                typePeriod: 0,
                //namePeriod: 'Rango: últimas 3 horas',
                //statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '3hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: '3h',
                typePeriod: 1,
                //namePeriod: 'Rango: últimas 3 horas',
                //statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '6hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: '6h',
                typePeriod: 2,
                //namePeriod: 'Rango: últimas 3 horas',
                //statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '12hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: '12h',
                typePeriod: 3,
                //namePeriod: 'Rango: últimas 3 horas',
                //statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 4,
                //namePeriod: 'Rango: último día',
                //statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '2dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "2d",
                typePeriod: 5,
                //namePeriod: 'Rango: últimos 3 días',
                //statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } 
    }
    
    handleOpenObjectiveModal = event => {      
        const objId = event.currentTarget.id
        const objName = event.currentTarget.value       
        if (this.state.openObjectiveModal == false){
            this.setState({
                openObjectiveModal: true,
                objIdModal: objId,
                objNameModal: objName
            })
        }        
    };
    
    handleCloseObjectiveModal  = event => {
        this.setState({
            openObjectiveModal: false,
        })
    };

    scroll = (scrollOffset) => {
        const scrollContainer = ReactDOM.findDOMNode(this.scrollRef);
        scrollContainer.scrollLeft += scrollOffset;
    };

    handleState=(e,x)=>{
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        var stateObj =  x.nombre
        var statusName = "Activos"
        if(stateObj===t('filter.status-list.Downtime')){
            statusName = "Downtime"
            this.setState({
                changeFilter : !this.state.changeFilter, 
                filter : "Downtime"
            });
        }else if(stateObj===t('filter.status-list.Downtime-Parcial')){
            statusName = "Downtime-Parcial"
            this.setState({
                changeFilter : !this.state.changeFilter, 
                filter : "Downtime-Parcial"
            });
        }else if(stateObj===t('filter.status-list.Uptime')){
            statusName = "Uptime"
            this.setState({
                changeFilter : !this.state.changeFilter, 
                filter : "Uptime"
            })
        }else if(stateObj===t('filter.status-list.Todos')){
            statusName = "Todos"
            this.setState({
                changeFilter : !this.state.changeFilter, 
                filter : "Todos"
            })
        }else if(stateObj===t('filter.status-list.Activos')){
            statusName = "Activos"
            this.setState({
                changeFilter : !this.state.changeFilter, 
                filter : "Activos"
            });
        }
        sessionStorage.setItem("filterOperative",  statusName)

        const parsed = queryString.parse(this.props.location.search);
        const activeTab = parsed?.tab ?? '1';

        const queryParamsParsed = queryString.parse(document.location.search);
        queryParamsParsed['tab'] = activeTab
        queryParamsParsed['etiquetas'] = this.state.filterTagsId.join('T')
        queryParamsParsed['estado'] = statusName
        queryParamsParsed['filterType'] = this.state.filterTagsType
        window.history.replaceState(
            null,
            'Vista Rápida por Isp / Semáforo',
            `/quickviewisplights?${queryString.stringify(queryParamsParsed)}`
        )
    }

    updateEtiquetas = (etiquetas, filterType) => {
        const ids = etiquetas.map(etiqueta => etiqueta.etiqueta_id)
        this.setState({filterTagsId: ids, filterTagsType: filterType})

        const parsed = queryString.parse(this.props.location.search);
        const activeTab = parsed?.tab ?? '1';

        const queryParamsParsed = queryString.parse(document.location.search);
        queryParamsParsed['tab'] = activeTab
        queryParamsParsed['etiquetas'] = ids.join('T')
        queryParamsParsed['estado'] = this.state.filter
        queryParamsParsed['filterType'] = filterType
        console.log({queryParamsParsed});
        
        window.history.replaceState(
            null,
            'Vista Rápida por Isp / Semáforo',
            `/quickviewisplights?${queryString.stringify(queryParamsParsed)}`
        )
    }

    objectivesListFilteredByTags = () => {
        if (this.state.filterTagsId.length === 0) return this.state.objectivesList
        let newListObjectives = []
        for (const state in this.state.listObjetivesData) {
            if(this.state.listObjetivesData[state]) {
                const filtered = this.state.listObjetivesData[state].filter(obj => {
                    if (!obj.Etiquetas) return false
                    let tieneEtiquetas = true

                    if (this.state.filterTagsType === "AND") {
                        for (const id of this.state.filterTagsId) {
                            if (!obj.Etiquetas.find(et => et.etiqueta_id === id)) {
                                tieneEtiquetas = false
                                break;
                            }
                        }
                    } else {
                        tieneEtiquetas = obj.Etiquetas.filter(et => this.state.filterTagsId.includes(et.etiqueta_id)).length > 0
                    }
                    return tieneEtiquetas
                })
                newListObjectives = [...newListObjectives, ...filtered]
            }
        }
        return newListObjectives
    }

    handleChangeShowPatronesInversos = (event) => {
        this.setState({
            showPatronesInversos: event.target.checked
        });
    };
    
    render() {
        const { isLoading, date, settingsEl, isInfo, loadObjectiveData, listObjetivesData,
            objIdModal, objNameModal, openObjectiveModal, periodEl, typeGraph, period, isOneHour, namePeriodPorlet, 
            typePeriod, nodesList, groupedNodes, nodesIdList, filterList, filter, fromBoards, nodesMonitorsIdList} = this.state;
        const { classes, className, handleClose, isForModal, ...rest } = this.props;

        const objectivesList = this.objectivesListFilteredByTags()
        const rootClassName = classNames(classes.root, className);
        const showSettingsEl = Boolean(settingsEl);
        const showIsInfo = Boolean(isInfo);
        const showPeriodEl = Boolean(periodEl);
        let isForModalEl = false
        if (isForModal == true){
            isForModalEl = true
        }
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (isLoading) {
            return (
                <Grid style={{fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', height: '85px', fontSize: '14px', color: '#666666', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                        <CircularProgress variant="indeterminate" size={24} thickness={4} />
                    </Grid>
                    <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                        {t('text.loading')}
                    </Grid>
                </Grid>
            );
        }

        return (
            <Portlet  className={rootClassName}>
                <PortletHeader className={classes.header} style={{borderBottom: 'none'}}>
                    {fromBoards ? 
                        <div style={{
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <NavLink to={{pathname: '/boards', search: getQueryParams()}}>
                            <Button 
                            style={{color: "#fff", background: "#909090"}}
                            >
                                Regresar
                            </Button>
                            </NavLink>
                        </div>
                    :null}
                        <div style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                            <Avatar variant="rounded" className={classes.rounded}>
                            <UpdateIcon /> 
                            </Avatar>
                            <Typography  className={classes.updateTime}>
                                    &nbsp; {t('text.last-update')}: {date} 
                            </Typography>
                        </div>
                   
                        <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                            <IconButton
                                onClick={this.handleShowSettings}
                                styles={{float:'right'}}
                            >
                                <SettingsOutlinedIcon />
                            </IconButton>
                            {isForModalEl ?
                                <IconButton 
                                    onClick={handleClose}
                                >
                                    <ClearIcon/>
                                </IconButton>
                            : null}
                        </div>
                    <Popover
                        anchorEl={periodEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        onClose={this.handleClosePeriod}
                        open={showPeriodEl}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}>
                        <Period onClick={this.handlePeriodClick} period={period} typeGraph={typeGraph} isOneHour={isOneHour}/>
                    </Popover>
                    <Popover
                        anchorEl={settingsEl}
                        onClose={this.handleCloseSettings}
                        open={showSettingsEl}
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                            }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                    }}
                    >
                    <IconButton style={{display: 'flex', justifyContent: 'space-between'}} 
                        onClick={this.handleRefresh}
                    > 
                        <RefreshIcon style={{ color:'#66788A'}} /><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>{t('text.update')}</Typography>    
                    </IconButton>
                                    
                </Popover>
                </PortletHeader>
                <PortletContent className={classes.content}>
                    {loadObjectiveData ?
                        <div>
                            <Grid container spacing={2}>
                                <Grid item lg={6} md={6} sm={12}>
                                    <Filter
                                        list={filterList}
                                        label={t('text.select-status')} 
                                        InfoAutoComplete={this.handleState}
                                        placeholder={t('text.status')}
                                        default={t('filter.status-list.'+filter)}
                                    />
                                </Grid>
                                <Grid item lg={6} md={6} sm={12}>
                                    <FilterTags
                                        listObjectives={[]}
                                        updateEtiquetas={(etiquetas, filterType = "OR") => this.updateEtiquetas(etiquetas, filterType)}
                                        tagsId={this.state.filterTagsId}
                                        preload={true}
                                        filterTagsType={this.state.filterTagsType}
                                        showFilterType={true}
                                    />
                                </Grid>
                            </Grid>
                            <div style={{ position: 'relative' }}>
                                <div style={{ 
                                    position: 'fixed',
                                    bottom: '24px',
                                    right: '280px', // Aumenta este valor (ej. 90px o 100px) para dejar espacio al otro botón
                                    zIndex: 1000,
                                    backgroundColor: '#ffffff',
                                    borderRadius: '30px',
                                    border: '1px solid #e0e0e0',
                                    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.2)',
                                    padding: '6px 16px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    {/* 1. Control Switch */}
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                inputProps={{ "aria-label": "primary checkbox" }}
                                                checked={this.state.showPatronesInversos}
                                                onChange={this.handleChangeShowPatronesInversos}
                                                color="primary"
                                                size="small"
                                            />
                                        }
                                        label={
                                            <Typography variant="body2" style={{ fontWeight: 500, color: '#444' }}>
                                                {t('quickview-isp.switch.text')}
                                            </Typography>
                                        }
                                        style={{ margin: 0 }} // Elimina márgenes extra de Material UI
                                    />
                                    {/* Línea divisoria */}
                                    <Divider orientation="vertical" flexItem style={{ height: '20px', alignSelf: 'center' }} />
                                    {/* 2. Botones de Navegación */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                                        <IconButton onClick={() => this.scroll(-516)} size="small">
                                            <NavigateBeforeIcon fontSize="small"/>
                                        </IconButton>
                                        <IconButton onClick={() => this.scroll(516)} size="small">
                                            <NavigateNextIcon fontSize="small"/>
                                        </IconButton>
                                    </div>
                                    {/* 3. Contador de Monitores */}
                                    <Typography variant="subtitle2" style={{ color: '#111', fontWeight: 600, whiteSpace: 'nowrap' }}>
                                        {Object.keys(groupedNodes).length + " " + t('text.monitors')}
                                    </Typography>
                                </div>
                                <div style={{ float:'right'}}>
                                    <IconButton onClick={() => this.scroll(-516)}><NavigateBeforeIcon/></IconButton>
                                    <IconButton onClick={() => this.scroll(516)}><NavigateNextIcon/></IconButton>
                                    <Typography variant="h6" style={{color:'black'}}>
                                        {Object.keys(groupedNodes).length+" "+t('text.monitors')}
                                    </Typography>
                                </div>
                                <TableContainer ref={(ref) => (this.scrollRef = ref)} style={{ overflowX: 'auto' }}>
                                    <Table stickyHeader style={{width: '100%'}} >
                                        <TableHead>
                                            <Row>
                                                <Cell style={{backgroundColor:'#373537', maxWidth:'360px', minWidth:'360px', borderRight: "2px solid #e4dede", 
                                                                left: 0, position: "sticky", zIndex: 2}}> 
                                                    <Typography variant="h4" style={{color:'white'}}>{t('quickview-isp.table.text.objective')}</Typography>
                                                </Cell>
                                                {Object.keys(groupedNodes).map(key => (
                                                    key != 0 ?
                                                        <Cell style={{backgroundColor:'#373537', maxWidth:'130px', minWidth:'130px', borderRight: "2px solid #e4dede"}}>
                                                            <Typography variant="h5" style={{color:'white'}}>{groupedNodes[key][0].titulo.substr(0,10)}</Typography>
                                                            <Typography style={{color:'white'}}>{groupedNodes[key][0].subtitulo.substr(0,15)}</Typography>
                                                        </Cell>
                                                    : null
                                                ))}
                                            </Row>
                                        </TableHead>
                                        
                                        {Object.keys(objectivesList).map(key => (
                                            filter === "Todos"||objectivesList[key].estado == filter ?
                                                <ObjectiveCell key={objectivesList[key].objetivo_id} objectivesList={objectivesList[key]} nodesIdList={nodesIdList} nodesMonitorsIdList={nodesMonitorsIdList} handleOpenObjectiveModal={this.handleOpenObjectiveModal} showPatronesInversos={this.state.showPatronesInversos}/>
                                            : filter==="Activos"&&objectivesList[key].estado !== "No monitoreo"?
                                                <ObjectiveCell key={objectivesList[key].objetivo_id} objectivesList={objectivesList[key]} nodesIdList={nodesIdList} nodesMonitorsIdList={nodesMonitorsIdList} handleOpenObjectiveModal={this.handleOpenObjectiveModal} showPatronesInversos={this.state.showPatronesInversos}/>
                                            : null
                                        ))}
                                    </Table>
                                </TableContainer>

                            </div>
                            
                        </div>
                        
                    :  <PerfectScrollbar>
                            <Typography
                                variant="h5">
                                <CircularProgress
                                    variant="indeterminate"
                                    size={24}
                                    thickness={4}
                                    />
                                <br/>
                                {t('text.loading')}
                            </Typography>
                        </PerfectScrollbar>}
                        <Dialog
                            maxWidth='lg'
                            fullWidth
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            open={openObjectiveModal}
                            onClose={this.handleCloseObjectiveModal}
                            closeAfterTransition
                            disableAutoFocus={true}
                            disableEnforceFocus={true}
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                                timeout: 500,
                            }}
                        >                                    
                        <Fade in={openObjectiveModal}>                          
                            <ListObjectiveModal obj={objIdModal} objName={objNameModal} listObjectives={listObjetivesData} handleClose={this.handleCloseObjectiveModal}/>                        
                        </Fade>
                        </Dialog>
                </PortletContent>
                
            </Portlet>
        )
    }
}

function FormattedChart(props) {
    return ( 
        <div>
            <div style={props.style}>
{/*                 <div style={{float:"left"}}>
                    <div style={{float:"left"}}>
                        <QueryBuilderIcon/>
                    </div>
                    <Typography  style={{width:"380px", height:"1px", float:"right", marginTop:"5px", paddingLeft:"3px"}} color="textSecondary" gutterBottom>
                        Última Actualización {props.date}
                    </Typography>
                </div> */}
                <Grid
                    container
                    spacing={2}
                    
                >           
                    <Grid item
                        sm={12}
                        xl={12}
                        xs={12}
                        >
                        {Object.keys(props.listObjectives).map(key => (
                            <Button id={props.listObjectives[key].objetivo_id} value={props.listObjectives[key].nombre} onClick={props.handleOpenObjectiveModal}>
                                {/*<GeneralStatusAvailabilityConsolidated objetivo_name={props.listObjectives[key].nombre} objetivo_id={props.listObjectives[key].objetivo_id} period={props.period}/>*/}
                            </Button>
                        ))}
                    </Grid> 
                </Grid>    
            </div>   
        </div>        
           
    )
}

function groupBy(objectArray, property) {
    return objectArray.reduce(function (acc, obj) {
        var key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
}
QuickViewIspFull.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired
};

export default compose(withRouter, withStyles(styles), withTranslation())(QuickViewIspFull);